export default __webpack_public_path__ + "assets/img/icon-collapse.e8cc1b6cd03eb90c4b6c49d5b00f73a3.svg";